import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { metaContentZodSchema } from "@@/shared/meta-content/meta-content";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { unitZodSchema } from "@@/shared/units-and-quantities/unit";
import { z } from "zod";
import { resourceIdFactory, resourceIdZodSchema } from "./resource-id";
import { resourceLinkZodSchema } from "./resource-link";

const resourceTableGroupZodObject = z.object({
    _id: resourceIdZodSchema,
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("RESOURCE_TABLE_GROUP"), //Virtual tables
    meta: metaContentZodSchema,
    unit: unitZodSchema,
    ownerId: providerIdZodSchema,
    resources: z.array(resourceLinkZodSchema),
    /**The number of seats  */
    quantity: z.number().int().positive(),

    /** If `true` the resource can be checked in.
     * If `false` the resource can not be checked in.
     * If not set, it defaults to `true`. */
    checkInEnabled: z.coerce.boolean().optional(),
    /** If `true` the resource allows unlimited number
     * of check ins to be true at once.
     * If `false` the resource can only be checked in
     * by one reservation at a time.
     * If not set, it defaults to `false`. */
    allowMultipleCheckIns: z.coerce.boolean().optional(),
});

type ResourceTableGroup = z.infer<typeof resourceTableGroupZodObject>;

const _resourceTableGroupFactoryParamsZodObject = resourceTableGroupZodObject
    .omit({
        _id: true,
        _createdAt: true,
        _type: true,
    })
    .and(z.object({ _id: resourceIdZodSchema.optional() }));

type FactoryParams = z.infer<typeof _resourceTableGroupFactoryParamsZodObject>;
const resourceTableGroupFactory = (
    params: FactoryParams,
): ResourceTableGroup => {
    return {
        _id: resourceIdFactory(),
        _createdAt: nowIsoAndUnix(),
        _type: "RESOURCE_TABLE_GROUP",
        ...params,
    };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isResourceTableGroup = (item: any): item is ResourceTableGroup => {
    if (!item) return false;
    if (item._type !== "RESOURCE_TABLE_GROUP") return false;
    return true;
};

export {
    //  isNotResourceTableGroup,
    isResourceTableGroup,
    resourceTableGroupFactory,
    resourceTableGroupZodObject,
};
export type { ResourceTableGroup };
